import { Module } from 'vuex'
import { RootState } from '../types'
import { AdminState } from './types'
import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'

export const admin: Module<AdminState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions
}
